/**
 * This import contains augmentations for the `@tanstack/react-table` module.
 * It must be imported first.
 */
import './augmentations.js';

// eslint-disable-next-line no-restricted-imports
export * from '@tanstack/react-table';
